<template>
    <section class="usps section section--floating">
        <div :class="['usps__container', { wrap: isLargeScreen }]">
            <div class="usps--list-wrap">
                <div :class="['usp-list', { wrap: !isLargeScreen }]">
                    <h2 class="usp-list__heading">
                        {{ $t('sections.owners_usps.security_heading') }}
                    </h2>
                    <div class="usp">
                        <img
                            :alt="$t('icon_img_alt.insurance')"
                            class="usp__icon"
                            src="~/assets/images/big-icons/insurance.svg"
                        />
                        <div class="usp_content">
                            <h3 class="usp__heading">{{ $t('sections.owners_usps.insurance_subheading') }}</h3>
                            <p class="usp__text">
                                {{ $t('sections.owners_usps.insurance_text') }}
                                <LocalizedLink :to="{ name: 'insurance' }">
                                    {{ $t('sections.owners_usps.insurance_read_more_link') }}
                                </LocalizedLink>
                            </p>
                        </div>
                    </div>
                    <div class="usp">
                        <img
                            :alt="$t('icon_img_alt.road_assistance')"
                            class="usp__icon"
                            src="~/assets/images/big-icons/tow.svg"
                        />
                        <div class="usp_content">
                            <h3 class="usp__heading">{{ $t('sections.owners_usps.road_assistance_subheading') }}</h3>
                            <p class="usp__text">
                                {{ $t('sections.owners_usps.road_assistance_text') }}
                            </p>
                        </div>
                    </div>
                    <div class="usp">
                        <img
                            :alt="$t('icon_img_alt.verified_users')"
                            class="usp__icon"
                            src="~/assets/images/big-icons/report.svg"
                        />
                        <div class="usp_content">
                            <h3 class="usp__heading">{{ $t('sections.owners_usps.verified_users_subheading') }}</h3>
                            <p class="usp__text">
                                {{ $t('sections.owners_usps.verified_users_text', { siteName: $config.siteName }) }}
                            </p>
                        </div>
                    </div>
                    <div class="usp">
                        <img
                            :alt="$t('icon_img_alt.secure_payments')"
                            class="usp__icon"
                            src="~/assets/images/big-icons/credit-card.svg"
                        />
                        <div class="usp_content">
                            <h3 class="usp__heading">{{ $t('sections.owners_usps.secure_payments_subheading') }}</h3>
                            <p class="usp__text">
                                {{ $t('sections.owners_usps.secure_payments_text') }}
                            </p>
                        </div>
                    </div>
                    <div class="usp">
                        <img
                            :alt="$t('icon_img_alt.phone_support')"
                            class="usp__icon"
                            src="~/assets/images/big-icons/seller.svg"
                        />
                        <div class="usp_content">
                            <h3 class="usp__heading">{{ $t('sections.owners_usps.support_subheading') }}</h3>
                            <p class="usp__text">
                                {{ $t('sections.owners_usps.support_text') }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="usps--list-wrap">
                <div :class="['usp-list', { wrap: !isLargeScreen }]">
                    <h2 class="usp-list__heading">
                        {{ $t('sections.owners_usps.simplicity_heading') }}
                    </h2>
                    <div class="usp">
                        <img
                            :alt="$t('icon_img_alt.you_decide')"
                            class="usp__icon"
                            src="~/assets/images/big-icons/king.svg"
                        />
                        <div class="usp_content">
                            <h3 class="usp__heading">{{ $t('sections.owners_usps.you_decide_subheading') }}</h3>
                            <p class="usp__text">
                                {{ $t('sections.owners_usps.you_decide_text') }}
                            </p>
                        </div>
                    </div>
                    <div class="usp">
                        <img
                            :alt="$t('icon_img_alt.calendar')"
                            class="usp__icon"
                            src="~/assets/images/big-icons/calendar.svg"
                        />
                        <div class="usp_content">
                            <h3 class="usp__heading">
                                {{ $t('sections.owners_usps.easier_availability_subheading') }}
                            </h3>
                            <p class="usp__text">
                                {{ $t('sections.owners_usps.easier_availability_text') }}
                            </p>
                        </div>
                    </div>
                    <div class="usp">
                        <img
                            :alt="$t('icon_img_alt.free_advertising')"
                            class="usp__icon"
                            src="~/assets/images/big-icons/website.svg"
                        />
                        <div class="usp_content">
                            <h3 class="usp__heading">{{ $t('sections.owners_usps.free_ads_subheading') }}</h3>
                            <p class="usp__text">
                                {{ $t('sections.owners_usps.free_ads_text', { siteName: $config.siteName }) }}
                            </p>
                        </div>
                    </div>
                    <div class="usp">
                        <img
                            :alt="$t('icon_img_alt.advertising')"
                            class="usp__icon"
                            src="~/assets/images/big-icons/megaphone.svg"
                        />
                        <div class="usp_content">
                            <h3 class="usp__heading">{{ $t('sections.owners_usps.more_advertising_subheading') }}</h3>
                            <p class="usp__text">
                                {{ $t('sections.owners_usps.more_advertising_text') }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="blue_bg" />
        <div class="cream_bg" />
    </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters(['isLargeScreen']),
    },
};
</script>
